import { Route, Routes } from "react-router";
import "./style/App.css";
import { Home } from "./pages/Home";
import { Auth } from "./pages/Auth";
import { Layout } from "./components/Layout";
import { memo, useEffect, useLayoutEffect, useState } from "react";
import media from "./service/state/media";
import { UserProfile } from "./pages/UserProfile";
import { PrivateRoute } from "./components/PrivateRoute";
import appState from "./service/state/app.state";
import Registration from "./pages/Registration";
import Alert from "./pages/Alert";
import Controller from "./pages/Controller";
import { Settings } from "./pages/Settings";

const App = () => {
  const [width, setWidth] = useState(window.innerWidth);
  useEffect(() => {
    media.handlerResize(width);
    const handleResize = (event) => {
      setWidth(event.target.innerWidth);
      media.handlerResize(width);
    };
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, [window.innerWidth]);

  useLayoutEffect(() => {
    if (localStorage.getItem("time_req_controller") !== null) {
      appState.setParameters(
        "time_req_controller",
        Number(localStorage.getItem("time_req_controller"))
      );
    } else {
      localStorage.setItem("time_req_controller", 30);
      appState.setParameters("time_req_controller", 30);
    }
  }, []);

  return (
    <Routes>
      <Route path="login" element={<Auth />} />
      <Route path="registration" element={<Registration />} />

      <Route path="/" element={<Layout />}>
        <Route element={<PrivateRoute />}>
          <Route path="/" element={<Home />} />
          <Route path="alert" element={<Alert />} />
          <Route path="myprofile" element={<UserProfile />} />
          <Route index path="home" element={<Home />} />
          <Route path="home/:id" element={<Controller />} />
        </Route>
        <Route path="setting" element={<Settings />} />
      </Route>
    </Routes>
  );
};

export default memo(App);
